<template>
  <div>
    <md-app-toolbar>
      <div class="md-toolbar-row">
        <BuildingStockHeader />
      </div>
    </md-app-toolbar>
    <div class="page-container">
      <md-app
        md-mode="fixed">
        <md-app-content class="page-content">
          <div class="page-layout">
            <div class="main__panel">
              <md-content>
                <div class="box">
                  <div
                    class="md-layout md-gutter">
                    <div class="md-layout-item">
                      <template>
                        <div>
                          <span class="md-headline">Import du parc bâti</span>
                          <md-button
                            @click="newFileImport.showModal = true"
                            class="md-primary float-right m-50">
                            Importer un nouveau fichier
                          </md-button>
                        </div>
                      </template>
                    </div>
                  </div>
                  <md-table
                    v-model="fileImports"
                    md-card
                    class="m-50">
                    <md-table-toolbar>
                      <h1 class="md-title">Historique des imports</h1>
                    </md-table-toolbar>
                    <md-table-row
                      :class="{ 'md-selected-single': item.id === selectedFileImport }"
                      slot="md-table-row"
                      slot-scope="{ item }">
                      <md-table-cell md-label="Date">{{ item.creation_date_display }}</md-table-cell>
                      <md-table-cell md-label="Fichier d'entrée">
                        <i class="material-icons middle-icons">cloud_download</i>
                        <a
                          class="middle-icons"
                          :href="item.input_file">{{ item.input_file_name }}</a>
                      </md-table-cell>
                      <md-table-cell md-label="Lieux importés">
                        {{ item.import_lines_display }}
                      </md-table-cell>
                      <md-table-cell md-label="État de l'import">
                        <div
                          v-if="item.import_state === 2">
                          <i class="material-icons">done <md-tooltip md-direction="top">Importé sans erreurs</md-tooltip></i>
                        </div>
                        <div
                          v-if="item.import_state === 3">
                          <i class="material-icons">not_interested <md-tooltip md-direction="top">Non importé car le fichier contient des erreurs</md-tooltip></i>
                        </div>
                      </md-table-cell>
                      <md-table-cell md-label="Avertissements à l'import">
                        <div v-if='item.import_warnings.length > 0'>
                          <a
                            href='#'
                            @click.prevent="showImportWarningsModal(item)">{{ item.import_warnings.length }} avertissement(s)
                          </a>
                        </div>
                        <div v-else>-</div>
                      </md-table-cell>
                      <md-table-cell md-label="Erreurs d'import">
                        <div v-if='item.import_errors.length > 0'>
                          <a
                            href='#'
                            @click.prevent="showImportErrorsModal(item)">{{ item.import_errors.length }} erreurs(s)
                          </a>
                        </div>
                        <div v-else>-</div>
                      </md-table-cell>
                      <md-table-cell md-label="Fichier d'erreur">
                        <div v-if='item.output_file_name'>
                          <i class="material-icons middle-icons">cloud_download</i>
                          <a
                            class="middle-icons"
                            :href="item.output_file">{{ item.output_file_name }}</a>
                        </div>
                        <div v-else>-</div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </md-content>
            </div>
          </div>
        </md-app-content>
      </md-app>
    </div>
    <div>
      <md-dialog-confirm
        :md-active.sync="confirmImportModal.showModal"
        :md-title="confirmImportModal.title"
        :md-content="confirmImportModal.content"
        md-confirm-text="Continuer"
        md-cancel-text="Annuler"
        @md-cancel="newFileImport.showModal = false; confirmImportModal.showModal = false"
        @md-confirm="importNewFile()" />

      <md-dialog
        :md-fullscreen='false'
        :md-active.sync="newFileImport.showModal">
        <md-dialog-title>Importer un nouveau fichier</md-dialog-title>
        <md-dialog-content>
          <md-field>
            <label>Fichier d'entrée</label>
            <md-file
              accept=".xlsx, .xlsm"
              @md-change="inputFileChange"
              placeholder="Parcourir..."
              v-model="newFileImport.input_file_name" />
          </md-field>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="newFileImport.showModal = false">Annuler</md-button>
          <md-button
            class="md-primary"
            :disabled='!newFileImport.input_file_name'
            @click="checkXLSXFileLines">Importer</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog
        :md-fullscreen='false'
        :md-active.sync="importWarningsModal.showModal">
        <md-dialog-title>Avertissements à l'import</md-dialog-title>
        <md-dialog-content>
          <md-table
            v-if="importWarningsModal.fileImport">
            <md-table-empty-state
              v-if="!importWarningsModal.fileImport && importWarningsModal.fileImport.import_warnings.length === 0"
              md-description="Aucun avertissement lors de l'import" />
            <md-table-row
              slot="md-table-row"
              v-for="(warning, i) in importWarningsModal.fileImport.import_warnings"
              :key="`warning-${importWarningsModal.fileImport.id}-${i}`">
              <md-table-cell md-label="Description">{{ warning }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="importWarningsModal.showModal = false">Fermer</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog
        :md-fullscreen='false'
        :md-active.sync="importErrorsModal.showModal">
        <md-dialog-title>Erreurs à l'import</md-dialog-title>
        <md-dialog-content>
          <md-table
            v-if="importErrorsModal.fileImport"
            v-model="importErrorsModal.fileImport.import_errors">
            <md-table-empty-state
              md-description="Aucune erreur lors de l'import" />
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }">
              <template
                v-if='item.global_msg'>
                <md-table-cell md-label="Onglet">-</md-table-cell>
                <md-table-cell md-label="Ligne">-</md-table-cell>
                <md-table-cell md-label="Colonne">-</md-table-cell>
                <md-table-cell md-label="Description">{{ item.global_msg }}</md-table-cell>
              </template>
              <template
                v-else>
                <md-table-cell md-label="Onglet">{{ item.worksheet_name }}</md-table-cell>
                <md-table-cell md-label="Ligne">{{ item.row }}</md-table-cell>
                <md-table-cell md-label="Colonne">{{ item.column }}</md-table-cell>
                <md-table-cell md-label="Description">{{ item.message }}</md-table-cell>
              </template>
            </md-table-row>
          </md-table>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="importErrorsModal.showModal = false">Fermer</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import session from '../api/session'
import BuildingStockHeader from '../components/BuildingStockHeader.vue'

export default {
  name: 'BuildingStockFileImport',
  components: { BuildingStockHeader },
  data () {
    return {
      confirmImportModal: {
        showModal: false,
        title: null,
        content: null
      },
      importWarningsModal: {
        showModal: false,
        fileImport: null
      },
      importErrorsModal: {
        showModal: false,
        fileImport: null
      },
      fileImports: [],
      selectedFileImport: null,
      newFileImport: {
        input_file_name: null,
        inputFileContent: null,
        showModal: false
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('routing/update_title', 'Parc bâti')
    this.$store.dispatch('routing/update_return_kwargs', null)
    this.loadApi()
  },
  methods: {
    async loadApi () {
      this.$store.dispatch('loading/begin_loading')
      const fileImportsResponse = await session.get('/api/userdata/file-import/')
      const fileImports = fileImportsResponse.data
      this.fileImports = fileImports
      this.$store.dispatch('loading/end_loading')
    },
    async importNewFile () {
      this.confirmImportModal.showModal = false
      this.$store.dispatch('loading/begin_loading')

      if (this.newFileImport.inputFileContent) {
        let formData = new FormData()
        formData.append('input_file', this.newFileImport.inputFileContent)

        try {
          const fileImportsResponse = await session.post('/api/userdata/file-import/',
            formData,
            {headers: {'Content-Type': 'multipart/form-data'}}
          )

          const newFileImport = fileImportsResponse.data
          this.fileImports.unshift(newFileImport)
          this.selectedFileImport = newFileImport.id
          this.newFileImport.input_file_name = null
          this.newFileImport.inputFileContent = null

          if (newFileImport.import_messages.error) {
            this.$store.commit('messages/SHOW', {
              label: 'Erreur',
              description: newFileImport.import_messages.error,
              duration: Infinity
            })
          } else if (newFileImport.import_messages.warning) {
            this.$store.commit('messages/SHOW', {
              label: 'Succès',
              description: newFileImport.import_messages.warning,
              duration: Infinity
            })
          } else if (newFileImport.import_messages.success) {
            this.$store.commit('messages/SHOW', {
              label: 'Succès',
              description: newFileImport.import_messages.success,
              duration: Infinity
            })
          }

          this.$store.dispatch('loading/end_loading')
        } catch (error) {
          // If a 400 error occurs, it means that the file wasn't uploaded properly
          if (error.response.status === 400) {
            this.$store.commit('errors/SHOW', {'title': 'Erreur réseau', 'content': 'Une erreur est survenue lors de l\'envoi de votre fichier vers notre serveur. Veuillez renouveler l\'envoi pour relancer l\'import de votre parc bâti.'})
          }
        }
      }
    },
    inputFileChange (inputFilesContent) {
      if (inputFilesContent.length > 0) {
        this.newFileImport.inputFileContent = inputFilesContent[0]
      } else {
        this.newFileImport.inputFileContent = null
        this.newFileImport.input_file_name = null
      }
    },
    showImportWarningsModal (fileImport) {
      this.importWarningsModal.showModal = true
      this.importWarningsModal.fileImport = fileImport
    },
    showImportErrorsModal (fileImport) {
      this.importErrorsModal.showModal = true
      this.importErrorsModal.fileImport = fileImport
    },
    async checkXLSXFileLines () {
      this.newFileImport.showModal = false

      if (this.newFileImport.inputFileContent) {
        this.$store.dispatch('loading/begin_loading')

        let formData = new FormData()
        formData.append('input_file', this.newFileImport.inputFileContent)

        try {
          const checkXLSXLinesResponse = await session.post('/api/userdata/file-import/check-disabled-lines/',
            formData,
            {headers: {'Content-Type': 'multipart/form-data'}}
          )

          const linesCountDetails = checkXLSXLinesResponse.data
          const importedLinesNumber = linesCountDetails.imported_lines_number
          const totalLinesNumber = linesCountDetails.total_lines_number

          if (importedLinesNumber !== totalLinesNumber) {
            this.confirmImportModal.title = "Validation de l'import"
            this.confirmImportModal.content = `Le fichier que vous souhaitez importer comporte ${totalLinesNumber} lieux. <br> Le nombre de lieux à importer est : ${importedLinesNumber} sur ${totalLinesNumber}. <br><br> Les lieux qui existent déjà dans le logiciel mais qui ne sont plus à importer seront supprimés de la base de données.`
          } else {
            this.confirmImportModal.title = "Confirmer l'import des données ?"
            this.confirmImportModal.content = "<strong>Attention</strong>, cette action va écraser l'ensemble des données de votre Parc Bati. <br> Cliquez sur <strong>Continuer</strong> pour effectuer l'opération."
          }
          this.confirmImportModal.showModal = true
          this.$store.dispatch('loading/end_loading')
        } catch (error) {
          // If a 400 error occurs, it means that the file wasn't uploaded properly
          if (error.response.status === 400) {
            if (error.response.data.error) {
              const errorMsg = `Une erreur a été rencontrée lors de la lecture de votre fichier : <strong>${error.response.data.error}</strong>. <br> Veuillez corriger l'erreur, puis renouveler l'envoi pour relancer l'import de votre parc bâti.`
              this.$store.commit('errors/SHOW', {'title': 'Fichier invalide', 'content': errorMsg})
            } else {
              this.$store.commit('errors/SHOW', {'title': 'Erreur réseau', 'content': 'Une erreur est survenue lors de l\'envoi de votre fichier vers notre serveur. Veuillez renouveler l\'envoi pour relancer l\'import de votre parc bâti.'})
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  overflow: auto;
  height: calc(100vh - 64 * 2px);
}

.page-layout {
  display: flex;
  height: min-content;
}

.main__panel {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 20px;
  }
}

.m-50 {
  margin-top: 50px;
}

.middle-icons {
  display: inline-block;
  vertical-align: middle;
}

.material-icons {
  font-size: 20px;
  margin-right: 3px;
}

</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/BuildingStockFileImport.vue